export { default } from 'react-bootstrap/Image';
export { default as Figure } from 'react-bootstrap/Figure';
